import { createContext } from 'react'

/**
 * De definitie van de openbare vragenlijst, zoals getPublicQuestionnaire die
 * teruggeeft (functions/questionnaires/getPublicQuestionnaire.js). Staat er een
 * waarde in, dan lezen FieldType, Section, TopLevelFields en de AI-interviewer
 * hieruit in plaats van uit Firestore: anoniem mag dat niet meer. Buiten de
 * openbare pagina is de waarde null en lezen ze zoals altijd.
 *
 * @typedef {object} PublicQuestionnaireData
 * @property {Array<object>} questionnaires
 * @property {Array<object>} fields - Op Position, zonder verwijderde
 * @property {Array<object>} researches
 * @property {Array<object>} moments
 * @property {Object<string, Array<object>>} options - Per vraag-id
 * @property {Object<string, Array<object>>} matrixRows - Per vraag-id
 * @property {Object<string, Array<object>>} matrixColumns - Per vraag-id
 */

/** @type {import('react').Context<PublicQuestionnaireData|null>} */
const PublicQuestionnaireContext = createContext(null)

export default PublicQuestionnaireContext
